import React, { FC } from 'react';
import { removeCentsFromAmount } from '@/utils/currency';

interface SubscriberShopPriceProps {
  priceCentsSubscriberShop?: number | null;
  formattedPrice?: string | null;
  className?: string;
}

/**
 * Extracts the currency symbol from a formatted price string
 * @example "$90" -> "$", "A$90" -> "A$", "£90" -> "£", "€90" -> "€"
 */
const extractCurrencySymbol = (formattedPrice: string): string => {
  const match = formattedPrice.match(/^([^\d\s]+)/);
  return match ? match[1] : '$';
};

/**
 * Formats a price in cents using the currency symbol from the original formatted price
 */
const formatPriceWithCurrency = (
  priceCents: number,
  currencySymbol: string,
): string => {
  const priceInDollars = priceCents / 100;
  const formattedNumber = priceInDollars.toFixed(2);
  return `${currencySymbol}${formattedNumber}`;
};

const SubscriberShopPrice: FC<SubscriberShopPriceProps> = ({
  priceCentsSubscriberShop,
  formattedPrice,
  className = 'text-lg font-bold',
}) => {
  if (!formattedPrice) return null;

  if (priceCentsSubscriberShop) {
    const currencySymbol = extractCurrencySymbol(formattedPrice);
    const subscriberPrice = formatPriceWithCurrency(
      priceCentsSubscriberShop,
      currencySymbol,
    );

    return (
      <div className="flex items-center gap-2">
        <p className={className}>{removeCentsFromAmount(subscriberPrice)}</p>
        <p className="text-lg font-normal text-gray-500 line-through">
          {removeCentsFromAmount(formattedPrice)}
        </p>
      </div>
    );
  }

  return <p className={className}>{removeCentsFromAmount(formattedPrice)}</p>;
};
export default React.memo(SubscriberShopPrice);
